<template>
    <div>
        <v-form name="manageRrspForm" ref="manageRrspForm">
            <div class="tw-flex tw-flex-col">
                <!-- data edit div -->
                <div class="tw-flex tw-justify-between tw-gap-4 tw-mb-2 tw-p-2">
                    <div class="tw-flex tw-flex-col tw-gap-2">
                        <div class="tw-flex tw-gap-2">
                            <v-text-field
                                v-model="member.certificate_number"
                                label="Certificate number"
                                dense
                                hide-details="auto"
                                :error-messages="errors?.certificate_number"
                                class="tw-mb-2"
                                @change="saveRrspDetails"
                            ></v-text-field>
                            <date-picker
                                v-model="member.voluntary_start_date"
                                dense
                                hide-details="auto"
                                color="primary"
                                display-label="Date start (Voluntary)"
                                reactive
                                :error-messages="errors?.voluntary_start_date"
                                @change="saveRrspDetails"
                            ></date-picker>
                            <date-picker
                                v-model="member.voluntary_end_date"
                                dense
                                hide-details="auto"
                                color="primary"
                                display-label="Date end (Voluntary)"
                                reactive
                                :error-messages="errors?.voluntary_end_date"
                                @change="saveRrspDetails"
                            ></date-picker>
                        </div>

                        <div class="tw-flex tw-gap-2">
                            <div class="tight-checkbox-spacing custom-border">
                                <div>
                                    <p style="font-size: 14px; color: rgba(0, 0, 0, 0.6); padding: 0; margin: 0;">Producer Contribution</p>
                                    <div class="mt-0 py-0" dense row :error-messages="errors?.contribution_producer" hide-details="auto">
                                        <v-checkbox
                                            :input-value="member.contribution_producer === constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED"
                                            :label="constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED"
                                            @click.stop="toggleCheckbox('contribution_producer', constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED)"
                                            class="radio-checkbox-style"
                                        ></v-checkbox>
                                        <v-checkbox
                                            :input-value="member.contribution_producer === constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED"
                                            :label="constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED"
                                            @click.stop="toggleCheckbox('contribution_producer', constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED)"
                                            class="radio-checkbox-style"
                                        ></v-checkbox>
                                    </div>
                                </div>

                            </div>
                            <div class="ml-16 tight-checkbox-spacing custom-border">
                                <p style="font-size: 14px; color: rgba(0, 0, 0, 0.6); padding: 0; margin: 0;">Voluntary</p>
                                <div class="mt-0 py-0" dense row :error-messages="errors?.contribution_producer" hide-details="auto">
                                    <v-checkbox
                                        :input-value="member.contribution_voluntary === constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED"
                                        :label="constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED"
                                        @click.stop="toggleCheckbox('contribution_voluntary', constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_REGISTERED)"
                                    ></v-checkbox>
                                    <v-checkbox
                                        :input-value="member.contribution_voluntary === constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED"
                                        :label="constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED"
                                        @click.stop="toggleCheckbox('contribution_voluntary', constants.CONTRIBUTION_VOLUNTARY.CONTRIBUTION_VOLUNTARY_NON_REGISTERED)"
                                    ></v-checkbox>
                                </div>
                            </div>
                            <div class="ml-16 tight-checkbox-spacing custom-border">
                                <p style="font-size: 14px; color: rgba(0, 0, 0, 0.6); padding: 0; margin: 0;">RRSP Enrolled</p>
                                <div class="mt-0 py-0" dense row :error-messages="errors?.rrsp_enrolled" hide-details="auto">
                                    <v-checkbox
                                        :input-value="member.rrsp_enrolled === 'Yes'"
                                        label="Yes"
                                        @click.stop="toggleCheckbox('rrsp_enrolled', 'Yes')"
                                    ></v-checkbox>
                                    <v-checkbox
                                        :input-value="member.rrsp_enrolled === 'No'"
                                        label="No"
                                        @click.stop="toggleCheckbox('rrsp_enrolled', 'No')"
                                    ></v-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tw-flex tw-flex-col tw-gap-2 tw-flex-1">
                        <v-textarea
                            v-model="member.rrsp_note"
                            label="Notes"
                            outlined
                            rows="6"
                            dense
                            :error-messages="errors?.rrsp_note"
                            hide-details="auto"
                            @change="saveRrspDetails"
                        ></v-textarea>
                        <div class="tw-flex tw-gap-2 tw-justify-end">
                            <v-btn @click="londonLifeModal = !londonLifeModal" class="main-btn">
                                Canada Life Data Feed
                            </v-btn>
                            <v-btn @click="deleteLondonLifeModal = !deleteLondonLifeModal" class="main-btn">
                                Delete Canada Life Data Feed
                            </v-btn>
                        </div>
                    </div>
                </div>

                <!-- summary div -->
                <div class="tw-py-2 tw-flex tw-items-end tw-justify-between">
                    <div class="tw-flex tw-gap-2">
                        <date-picker
                            v-model="filters.date_deposit"
                            :yearOnly="true"
                            min="2000"
                            :max="`${new Date().getFullYear() }`"
                            clearable
                            dense
                            color="primary"
                            label="Filter Year"
                            display-label="Filter Year"
                            ref="dateDepositPicker"
                            hide-details="auto"
                        />
                        <v-autocomplete
                            v-model="filters.month_deposit"
                            :items="month_list"
                            dense
                            clearable
                            color="primary"
                            label="Filter Months"
                            display-label="Filter Months"
                            hide-details="auto"
                            outlined
                            multiple
                        />
                        <v-autocomplete
                            v-model="filters.productions"
                            :items="production_list"
                            dense
                            clearable
                            color="primary"
                            label="Filter Productions"
                            display-label="Filter Productions"
                            hide-details="auto"
                            outlined
                            multiple
                            :loading="is_loading"
                            :disabled="is_loading"
                        />
                    </div>
                    <div>
                        <table class="tw-table-auto tw-min-w-full tw-text-right tw-text-sm tw-font-light">
                            <thead class="tw-font-medium tw-dark:border-neutral-500">
                            <tr>
                                <th scope="col" class="tw-pb-2"></th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Net Pay</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Vacation Pay</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Gross</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">RRSP Daily</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Employer</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Employee </th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Top up</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Balance</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="tw-text-secondary font-weight-black tw-pl-2">Totals</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.net_pay) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.vacation_pay) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.gross) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.rrsp_daily) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.pension) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.pension_deducted) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.pension_deducted_employee) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.pension_deducted_total) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </v-form>

        <smart-table
            ref="table_rrsp"
            endpoint="memberdataexcel.list"
            item-key="member_data_excels_id"
            :headers="headers"
            :options_payload="{only_rrsp:true}"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            @fetch-complete="summarizeData"
        >
            <template v-slot:item.member_data_excels_id="{ isMobile, item, header, value, index}">
                <div>{{ value }}</div>
            </template>
            <template v-slot:item.batch_id="{ isMobile, item, header, value, index}">
                <div>{{ value }}</div>
            </template>
            <template v-slot:item.date_deposit="{ isMobile, item, header, value, index}">
                <div>{{ $root.getAsIsoDate(value) }}</div>
            </template>
            <template v-slot:item.period_ending="{ isMobile, item, header, value, index}">
                <div>{{ $root.getAsIsoDate(value) }}</div>
            </template>
            <template v-slot:item.productions.name="{ isMobile, item, header, value, index}">
                <div>{{ item.production_name }}</div>
            </template>
            <template v-slot:item.contribution_producer="{ isMobile, item, header, value, index}">
                <div>{{ value }}</div>
            </template>
            <template v-slot:item.contribution_voluntary="{ isMobile, item, header, value, index}">
                <div>{{ value }}</div>
            </template>
            <template v-slot:item.net_pay="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.vacation_pay="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.gross="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.rrsp_daily="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.pension="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.pension_deducted="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.pension_deducted_employee="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
            <template v-slot:item.pension_deducted_total="{ isMobile, item, header, value, index}">
                <div>{{  $root.formatCurrency(Number(value)) }}</div>
            </template>
        </smart-table>

        <london-life-data-feed-modal
            v-model="londonLifeModal"
        ></london-life-data-feed-modal>
        <delete-london-life-data-feed-modal
            v-model="deleteLondonLifeModal"
        ></delete-london-life-data-feed-modal>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable.vue";
    import DatePicker from "@/Generic/DatePicker.vue";
    import LondonLifeDataFeedModal from "./Modals/LondonLifeDataFeedModal.vue";
    import DeleteLondonLifeDataFeedModal from "./Modals/DeleteLondonLifeDataFeedModal.vue";

    export default {
        name: "MembersShowRRSP",
        components: {
            DatePicker,
            SmartTable,
            LondonLifeDataFeedModal,
            DeleteLondonLifeDataFeedModal,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            }
        },
        data() {
            return {
                member: this.input,
                is_loading: true,
                filters: {
                    date_deposit: undefined,
                    month_deposit: undefined,
                    productions: undefined,
                },
                londonLifeModal: false,
                deleteLondonLifeModal: false,
                errors: null,
                summary_data: null,
                production_list: null,
                month_list: [
                    {text: 'January',   value: '01'},
                    {text: 'February',  value: '02'},
                    {text: 'March',     value: '03'},
                    {text: 'April',     value: '04'},
                    {text: 'May',       value: '05'},
                    {text: 'June',      value: '06'},
                    {text: 'July',      value: '07'},
                    {text: 'August',    value: '08'},
                    {text: 'September', value: '09'},
                    {text: 'October',   value: '10'},
                    {text: 'November',  value: '11'},
                    {text: 'December',  value: '12'},
                ],
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'member_data_excels_id',    text: 'Record ID',                  align: `start`,     sortable: true,   filterable: false, },
                    {value: 'batch_id',                 text: 'Batch ID',                   align: `start`,     sortable: true,   filterable: false, },
                    {value: 'date_deposit',             text: 'Deposit Date',               align: `start`,     sortable: true,   filterable: true,     search: this.filters.date_deposit },
                    {value: 'period_ending',            text: 'Week Ending Date',           align: `start`,     sortable: true,   filterable: false, },
                    {value: 'productions.name',         text: 'Production',                 align: `start`,     sortable: true,   filterable: false, },
                    {value: 'contribution_producer',    text: 'Producer Contribution',      align: `start`,     sortable: true,   filterable: false, },
                    {value: 'contribution_voluntary',   text: 'Voluntary',                  align: `start`,     sortable: true,   filterable: false, },
                    {value: 'net_pay',                  text: 'Net Pay',                    align: `start`,     sortable: true,   filterable: false, },
                    {value: 'vacation_pay',             text: 'Vacation Pay',               align: `start`,     sortable: true,   filterable: false, },
                    {value: 'gross',                    text: 'Gross',                      align: `start`,     sortable: false,  filterable: false, },
                    {value: 'rrsp_daily',               text: 'RRSP Daily',                 align: `start`,     sortable: true,   filterable: false, },
                    {value: 'pension',                  text: 'Employer (RRSP 1)',          align: `start`,     sortable: true,   filterable: false, },
                    {value: 'pension_deducted',         text: 'Employer (RRSP 1 Deducted)', align: `start`,     sortable: true,   filterable: false, },
                    {value: 'pension_deducted_employee',text: 'Top up (RRSP 2)',            align: `start`,     sortable: true,   filterable: false, },
                    {value: 'pension_deducted_total',   text: 'Total',                      align: `start`,     sortable: false,  filterable: false, },
                    {value: 'user_id',                  text: 'User',                       align: ` d-none`,   sortable: true,   filterable: true,     search: this.member.id },
                    {value: 'production_id',            text: 'Production ID',              align: ` d-none`,   sortable: true,   filterable: true,     search: this.filters.productions },
                    {value: 'month_deposit',            text: 'month_deposit',              align: ` d-none`,   sortable: true,   filterable: true,     search: this.filters.month_deposit},
                ]
            },
        },
        mounted() {
            this.getDeferredValuelists()
        },
        methods: {
            formatTimestamp(timestamp) {
                return new Date(timestamp).toISOString().split('T')[0]
            },
            toFixedNumDecimals(value, num_decimals) {
                if (typeof value !== 'number') return value
                return value.toFixed(num_decimals)
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 100
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [100, 500, 1000]
            },

            saveRrspDetails() {
                if (this.$refs.manageRrspForm.validate()) {
                    let formData = this.member
                    let url = route('members.update', this.member.id)
                    let method = 'put'

                    axios({
                        method: method,
                        url: url,
                        data: formData,
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.snackbar.success('Changes have been saved')
                                this.$root.is_dirty = false
                                this.$emit('successful-manage-rrsp-save')
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknown error.')
                            }
                        })
                        .catch((error) => {
                            if( error?.response ) {
                                this.$root.snackbar.error(error.response.data.message)
                                this.errors = error.response?.data?.errors
                            } else {
                                console.log(error)
                                this.$root.snackbar.error(error)
                            }
                            this.saveLoading = false
                        })
                }
            },
            summarizeData() {
                this.summary_data = this.$refs.table_rrsp._data.summary_list
            },
            getDeferredValuelists() {
                axios.post(route('productions.valuelist'))
                    .then((response)=>{
                        this.production_list= response?.data?.map(prod => ({text: prod.text, value: prod.value}))
                        this.is_loading = false
                    })
            },
            toggleCheckbox(groupName, value) {
                if (this.member[groupName] === value) {
                    this.$set(this.member, groupName, null)
                } else {
                    this.$set(this.member, groupName, value)
                }
                this.saveRrspDetails()
            },


        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>

<style>
.tight-checkbox-spacing .v-input__control {
    margin-bottom: -25px;
}

.custom-border {
    border: 1px solid #ccc;
    border-radius: 1px;
    padding: 8px;
    margin-top: 8px;
    width: 100%
}

</style>

